export default "__VITE_ASSET__BGFPhN1V__"